export default __webpack_public_path__ + "static/media/assemblyH3.f3d63f9c.png";